import { render, staticRenderFns } from "./WarehouseContact.vue?vue&type=template&id=c8a8fb7e"
import script from "./WarehouseContact.vue?vue&type=script&lang=js"
export * from "./WarehouseContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports